import React, { useEffect } from 'react';
import { useFormikContext, getIn } from 'formik';
import DynamicFieldList from '../dynamic-form/dynamic-field-list';

type PrestationFormProps = {
  compliantName: string;
  motifName: string;
  commentName: string;
  motifOptions: any[];
  disabled?: boolean;
};

export const PrestationForm: React.FC<PrestationFormProps> = ({
  compliantName,
  motifName,
  commentName,
  motifOptions,
  disabled,
}) => {
  const { values, setFieldValue } = useFormikContext();
  const noConfirmValue = getIn(values, compliantName);
  const canSelectMotif = !!(noConfirmValue && noConfirmValue === 'false') || noConfirmValue=== false;
  const formDisabled = getIn(values, 'formDisabled');

  useEffect(() => {
    if (disabled) {
      setFieldValue(compliantName, undefined);
    }
  }, [disabled, compliantName, setFieldValue]);

  useEffect(() => {
    if (!canSelectMotif) {
      setFieldValue(motifName, []);
      setFieldValue(commentName, '');
    }
  }, [canSelectMotif, motifName, commentName, setFieldValue]);

  return (
    <DynamicFieldList
      fields={{
        [compliantName]: {
          type: 'radio',
          name: 'qualityPrestation',
          label: 'Qualité de la prestation',
          disabled: disabled || formDisabled,
          options: [
            {
              value: 'true',
              label: 'Conforme',
            },
            {
              value: 'false',
              label: 'Non conforme',
            },
          ],
          grid: 6,
        },
        [motifName]: {
          type: 'select',
          label: 'Qualité de la prestation',
          options: motifOptions,
          multiple: true,
          disabled: !canSelectMotif || disabled || formDisabled,
          grid: 6,
        },
        [commentName]: {
          type: 'text',
          name: 'fact',
          label: 'Exposer les faits',
          multiline: true,
          disabled: !canSelectMotif || disabled || formDisabled,
          rows: 4,
          rowsMax: 15,
        },
      }}
    />
  );
};
